var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90625 1.20838C4.59249 1.51282 1.1875 5.10877 1.1875 9.5C1.1875 11.582 1.95225 13.4844 3.21724 14.9431L8.90625 9.25406V1.20838ZM10.0938 1.20838V8.90625H17.7916C17.501 4.78861 14.2114 1.49898 10.0938 1.20838ZM17.7916 10.0938H9.74594L4.05693 15.7828C5.51563 17.0477 7.41804 17.8125 9.5 17.8125C13.8912 17.8125 17.4872 14.4075 17.7916 10.0938ZM0 9.5C0 4.25329 4.25329 0 9.5 0C14.7467 0 19 4.25329 19 9.5C19 14.7467 14.7467 19 9.5 19C6.87681 19 4.501 17.936 2.78249 16.2175C1.06397 14.499 0 12.1232 0 9.5Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reportsIcon.4342949393cca89c8ac7b43471f8548f.svg";
export { ForwardRef as ReactComponent };